export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.23-1702.54",
  commitId: "f1f3eb13ebc5f5735bfb73ce51c82b0220f6ce9b",
  commitTime: "2026-09-23T17:02:54.000Z",
});
